/* ═══════════════════════════════════════
   UTILITIES — Throttle for Performance
   ═══════════════════════════════════════ */

function throttle(func, delay) {
  let lastCall = 0;
  return function(...args) {
    const now = Date.now();
    if (now - lastCall >= delay) {
      lastCall = now;
      func.apply(this, args);
    }
  };
}

/* ═══════════════════════════════════════
   PARTICLES — Performance-Aware Init
   ═══════════════════════════════════════ */

function initParticles() {
  const particlesContainer = document.getElementById('particles-js');
  if (!particlesContainer) return;
  
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) return;
  
  const viewportWidth = Math.max(window.innerWidth || 0, document.documentElement.clientWidth || 0);
  const isMobile = viewportWidth <= 768;
  
  if (isMobile) return;
  
  if (typeof particlesJS === 'undefined') return;
  
  const isLowEnd = navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4;
  if (isMobile && isLowEnd) return;
  
  const particleCount = isMobile ? 20 : 45;
  const interactivity = isMobile ? false : true;
  
  const config = {
    particles: {
      number: {
        value: particleCount,
        density: { enable: true, value_area: 1000 }
      },
      color: { value: ['#0091FF', '#00D4FF', '#2563eb'] },
      opacity: {
        value: 0.12,
        random: true,
        anim: { enable: true, speed: 0.4, opacity_min: 0.04 }
      },
      size: { value: 2.5, random: true },
      line_linked: { enable: false },
      move: { enable: true, speed: 0.5, direction: 'top', random: true, out_mode: 'out' }
    },
    interactivity: {
      detect_on: 'canvas',
      events: { onhover: { enable: interactivity, mode: 'bubble' } },
      modes: { bubble: { distance: 150, size: 3.5, duration: 2, opacity: 0.15, speed: 3 } }
    },
    retina_detect: true
  };
  
  particlesJS('particles-js', config);
}

// Fallback: Falls particles.js CDN schon geladen war BEVOR dieses Script (defer) lief,
// hat der onload-Callback initParticles() nicht gefunden. Jetzt nachholen:
if (window.__particlesReady && typeof particlesJS !== 'undefined') {
  initParticles();
}

let resizeTimer;
const handleResize = throttle(function() {
  if (window.pJSDom && window.pJSDom.length > 0) {
    window.pJSDom[0].pJS.fn.vendors.destroypJS();
    window.pJSDom = [];
    initParticles();
  }
}, 250);

window.addEventListener('resize', handleResize);

/* ═══════════════════════════════════════
   USP BAR — Scroll Handler
   ═══════════════════════════════════════ */

function initUSPBar() {
  const uspBar = document.querySelector('.usp-bar');
  if (!uspBar) return;
  
  const scrollThreshold = 50;
  
  function handleScroll() {
    const currentScroll = window.scrollY;
    if (currentScroll > scrollThreshold) {
      uspBar.classList.add('usp-bar--hidden');
    } else {
      uspBar.classList.remove('usp-bar--hidden');
    }
  }
  
  // Throttle scroll handler to ~60fps
  const throttledScroll = throttle(handleScroll, 16);
  window.addEventListener('scroll', throttledScroll, { passive: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUSPBar);
} else {
  initUSPBar();
}

/* ═══════════════════════════════════════
   HEADER — Scroll Handler
   ═══════════════════════════════════════ */

function initHeaderScroll() {
  const header = document.querySelector('store-header, .header');
  if (!header) return;
  
  const scrollThreshold = 50;
  
  function handleScroll() {
    const currentScroll = window.scrollY;
    if (currentScroll > scrollThreshold) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }
  
  // Throttle scroll handler to ~60fps
  const throttledScroll = throttle(handleScroll, 16);
  window.addEventListener('scroll', throttledScroll, { passive: true });
  handleScroll();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderScroll);
} else {
  initHeaderScroll();
}

/* ═══════════════════════════════════════
   DRAWER — Background handled via CSS Variables
   ═══════════════════════════════════════ */

/* ═══════════════════════════════════════
   AJAX ADD TO CART
   ═══════════════════════════════════════ */

function initAjaxCart() {
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('[data-ajax-cart]');
    if (!form) return;
    
    e.preventDefault();
    
    const submitBtn = form.querySelector('button[type="submit"]');
    if (!submitBtn) return;
    
    const originalHTML = submitBtn.innerHTML;
    
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span>...</span>';
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
    .then(response => response.json())
    .then(data => {
      submitBtn.innerHTML = '<span>&#10003; Im Warenkorb</span>';
      // Kein Redirect: geteilter Post-Add (Desktop-Toast / Mobile-Drawer) + „+1"-Bubble
      if (window.ebAfterAdd) window.ebAfterAdd();
      setTimeout(function () { submitBtn.innerHTML = originalHTML; submitBtn.disabled = false; }, 1800);
    })
    .catch(error => {
      submitBtn.innerHTML = originalHTML;
      submitBtn.disabled = false;
    });
  });
}

/* ═══════════════════════════════════════
   PRODUCT CARD BUY BUTTON
   ═══════════════════════════════════════ */

function initProductCardBuyButtons() {
  const buyButtons = document.querySelectorAll('.eb-products__btn-buy[data-product-handle]');
  
  const isLocalhost = window.location.hostname === '127.0.0.1' || 
                      window.location.hostname === 'localhost' ||
                      window.location.port === '9292';
  
  buyButtons.forEach(button => {
    button.addEventListener('click', async function(e) {
      e.preventDefault();
      
      const productHandle = this.getAttribute('data-product-handle');
      if (!productHandle) return;
      
      const originalHTML = this.innerHTML;
      
      this.disabled = true;
      this.innerHTML = '<span>...</span>';
      
      try {
        const productUrl = `/products/${productHandle}.js`;
        const productResponse = await fetch(productUrl);
        
        if (!productResponse.ok) {
          throw new Error(`Produkt nicht gefunden (${productResponse.status})`);
        }
        
        const product = await productResponse.json();
        const variant = product.variants.find(v => v.available) || product.variants[0];
        if (!variant) throw new Error('Keine Variante verfügbar');
        
        const cartData = { id: variant.id, quantity: 1 };
        
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(cartData)
        });
        
        if (!addResponse.ok) {
          if (addResponse.status === 401 && isLocalhost) {
            // Update Cart-Bubble via zentralen Manager (Localhost Fallback)
            if (window.CartBubbleManager) {
              window.CartBubbleManager.update(true);
            }
            
            this.innerHTML = '<span>Bitte auf Produktseite kaufen</span>';
            setTimeout(() => {
              this.innerHTML = originalHTML;
              this.disabled = false;
            }, 2000);
            return;
          }
          
          const errorData = await addResponse.json().catch(() => ({ description: 'Unbekannter Fehler' }));
          throw new Error(errorData.description || `Fehler beim Hinzufügen (${addResponse.status})`);
        }
        
        this.innerHTML = '<span>✓ Hinzugefügt!</span>';
        
        setTimeout(() => {
          this.innerHTML = originalHTML;
          this.disabled = false;
        }, 1500);
        
        // Update Cart-Bubble via zentralen Manager
        if (window.CartBubbleManager) {
          window.CartBubbleManager.update(true);
        }
        
        const cartDrawer = document.querySelector('cart-notification-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        
      } catch (error) {
        const errorMessage = error.message || 'Unbekannter Fehler';
        this.innerHTML = `<span style="color: #ef4444;">${errorMessage}</span>`;
        
        setTimeout(() => {
          this.innerHTML = originalHTML;
          this.disabled = false;
        }, 3000);
      }
    });
  });
}

/* ═══════════════════════════════════════
   INIT ALL
   ═══════════════════════════════════════ */

function initAll() {
  initAjaxCart();
  initProductCardBuyButtons();
  initFAQ();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  setTimeout(initAll, 100);
}

/* ═══════════════════════════════════════
   FAQ ACCORDION
   ═══════════════════════════════════════ */

function initFAQ() {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const faqToggles = document.querySelectorAll('[data-faq-toggle]');
  
  if (!faqToggles.length) return;

  function getFaqItem(el) {
    return el.closest('.eb-faq__item, .eb-product-faq__item');
  }

  function getFaqAnswer(item) {
    return item.querySelector('.eb-faq__answer, .eb-product-faq__answer');
  }

  // Markiere Listen-Items mit Checkmark/X-Icons für CSS-Styling
  document.querySelectorAll('.eb-faq__answer-content ul li').forEach(li => {
    const text = li.textContent;
    if (text.includes('✅')) {
      li.classList.add('has-checkmark');
    } else if (text.includes('❌')) {
      li.classList.add('has-x-mark');
    }
  });

  function handleFAQToggle(event) {
    event.preventDefault();
    
    const button = event.currentTarget;
    const item = getFaqItem(button);
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const answer = item ? getFaqAnswer(item) : null;
    
    if (!item || !answer) return;

    const scope = item.closest('.eb-faq, .eb-product-faq') || document;
    const allItems = scope.querySelectorAll('.eb-faq__item, .eb-product-faq__item');
    allItems.forEach(function(otherItem) {
      if (otherItem !== item) {
        const otherButton = otherItem.querySelector('[data-faq-toggle]');
        const otherAnswer = getFaqAnswer(otherItem);
        if (otherButton && otherAnswer) {
          otherButton.setAttribute('aria-expanded', 'false');
          otherAnswer.setAttribute('aria-hidden', 'true');
          otherItem.classList.remove('is-active');
        }
      }
    });

    if (isExpanded) {
      button.setAttribute('aria-expanded', 'false');
      answer.setAttribute('aria-hidden', 'true');
      item.classList.remove('is-active');
    } else {
      button.setAttribute('aria-expanded', 'true');
      answer.setAttribute('aria-hidden', 'false');
      item.classList.add('is-active');
      
      if (!prefersReducedMotion) {
        setTimeout(function() {
          const rect = item.getBoundingClientRect();
          const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
          
          if (!isVisible) {
            item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }, 300);
      }
    }
  }

  faqToggles.forEach(function(toggle) {
    toggle.addEventListener('click', handleFAQToggle);
  });

  faqToggles.forEach(function(toggle) {
    toggle.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleFAQToggle(event);
      }
    });
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('[data-faq-toggle]')) {
        initFAQ();
      }
    });
  }
}
